module.exports = {
  //siteUrl: `http://v3tests.embiq.com:8088`, // Site domain. Do not include a trailing slash!
  siteUrl: `https://embiq.com`, // Site domain. Do not include a trailing slash!
  apiUrl: "https://directus.embiq.com",
  apiToken: "Pji45mtDL8zMMhfu85CX",

  postsPerPage: 12, // Number of posts shown on paginated pages (changes this requires sometimes to delete the cache)

  siteTitleMeta: `EMBIQ The beauty of innovation`, // This allows an alternative site title for meta data for pages.
  siteDescriptionMeta: `We are a custom software development company empowering R&D teams and projects. Since 2009 we have participated in about 300 projects all around Europe and in the United States. We are not only feasible IT solution development service specialists but also partners and advisors.`, // This allows an alternative site description for meta data for pages.

  shareImageWidth: 1000, // Change to the width of your default share image
  shareImageHeight: 523, // Change to the height of your default share image

  shortTitle: `EMBIQ`, // Used for App manifest e.g. Mobile Home Screen
  siteIcon: `favicon.png`, // Logo in /static dir used for SEO, RSS, and App manifest
  backgroundColor: `#e9e9e9`, // Used for Offline Manifest
  themeColor: `#15171A`, // Used for Offline Manifest
};
